import React from 'react';
import { LineChart, Line, YAxis, ResponsiveContainer } from 'recharts';

const MiniChart = ({ history, color = '#00ff41' }) => {
  // Handle empty or invalid history
  if (!history || !Array.isArray(history) || history.length === 0) {
    return (
      <div className="mini-chart-placeholder" style={{ height: '40px' }}>
        <span style={{ fontSize: '9px', color: '#666' }}>No data</span>
      </div>
    );
  }

  // Take last 30 data points for mini chart
  const recentHistory = history.slice(-30);

  // Format data for recharts
  const chartData = recentHistory.map(point => ({
    value: parseFloat(point.price) || 0
  }));

  // Determine trend color based on first and last price
  const firstPrice = chartData[0]?.value || 0;
  const lastPrice = chartData[chartData.length - 1]?.value || 0;
  const trendColor = lastPrice >= firstPrice ? '#00ff41' : '#ff4444';

  // Compute Y domain so small price moves are visible
  const values = chartData.map(d => d.value);
  const min = Math.min(...values);
  const max = Math.max(...values);
  const padding = (max - min) * 0.1 || max * 0.005; // 10% padding, or 0.5% if flat

  return (
    <div className="mini-chart" style={{ width: '100%', height: '40px' }}>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={chartData} margin={{ top: 5, right: 5, bottom: 5, left: 5 }}>
          <YAxis domain={[min - padding, max + padding]} hide />
          <Line
            type="monotone"
            dataKey="value"
            stroke={trendColor}
            strokeWidth={1.5}
            dot={false}
            animationDuration={300}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MiniChart;
